<template>
  <footer class="main-footer">
    <div class="container-fluid">
      <div class="d-md-flex">
        <div class="align-items-center align-images-center py-5 py-md-4">
          <img
            src="@/assets/img/J-PAL_LAC_Logo_White@2x.png"
            class="mr-4 image-jpal"
          >
          <img
            src="@/assets/img/Logo_MIEP@2x.png"
            class="mr-4 image-miep"
          >
          <!-- <img src="@/assets/logo-presidencia.png" width="150"/> -->
          <img
            src="@/assets/img/logo-concillium.a8916a2d_3@2x.png"
            class="mr-4 image-concillium"
          >
        </div>
        <div class="ml-auto">
          <ul class="main-footer__list">
            <li>
              <a
                is="router-link"
                href="#"
                to="/about"
                title="Sobre Nosotros"
              >Sobre Nosotros</a>
            </li>
            <li>
              <a
                is="router-link"
                href="#"
                to="/data-source"
                title="Fuente de Datos"
              >Fuente de Datos</a>
            </li>
            <li>
              <a
                is="router-link"
                href="#"
                to="/contact"
                title="Contacto"
              >Contacto</a>
            </li>
          </ul>
          <div class="footer-disclaimer">
            {{ CONFIG.footer.disclaimer }} - v{{ CONFIG.VERSION }}
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
import CONFIG from '../config';

export default {
    name: 'MainFooter',
    data() {
        this.CONFIG = CONFIG;
        return {};
    },
};
</script>
<style lang="scss">
@import "../scss/style";
.main-footer {
    padding: 10px;
    color: white;
    background-color: $dark;

    &__list {
        list-style: none;
        margin: 0;
        padding: 0;
        @media (min-width: 768px) {
            text-align: right;
        }
        li {
            padding: 1rem 0;

            @media (min-width: 768px) {
                display: inline-block;
                padding: 0 1rem;
                margin-top: 1rem;
                margin-bottom: 1rem;
            }
            & + li {
                border-top: solid 1px rgba(white, 0.1);
                @media (min-width: 768px) {
                    border-top: none;
                    border-left: solid 1px rgba(white, 0.1);
                }
            }
            a {
                color: rgba(white, 0.5);
            }
        }
    }
}
.footer-disclaimer {
    text-align: center;
    opacity: 0.5;
    font-size: 0.725rem;
    @media (min-width: 768px) {
        text-align: right;
    }
}
.image-jpal {
    width: 22%;

    @media (max-width: 1025px) {
      width: 27%;
    }

    @media (max-width: 900px) {
      width: 29%;
    }

    @media (max-width: 767px) {
      width: 22%;
    }

    @media (max-width: 620px) {
      width: 27%;
    }

    @media (max-width: 515px) {
      width: 33%;
    }
}
.image-miep {
    width: 20%;

    @media (max-width: 1025px) {
      width: 25%;
    }

    @media (max-width: 900px) {
      width: 27%;
    }

    @media (max-width: 767px) {
      width: 20%;
    }

    @media (max-width: 620px) {
      width: 25%;
    }

    @media (max-width: 515px) {
      width: 30%;
    }
}
.image-concillium {
    width: 10%;

    @media (max-width: 1025px) {
      width: 13%;
    }

    @media (max-width: 900px) {
      width: 15%;
    }

    @media (max-width: 767px) {
      width: 10%;
    }

    @media (max-width: 620px) {
      width: 13%;
    }

    @media (max-width: 515px) {
      width: 15%;
    }
}
.align-images-center {
    text-align: left;

    @media (max-width: 767px) {
      text-align: center;
    }

    @media (max-width: 377px) {
      text-align: center;
      display: flex;
    }
}
</style>
